import { ShowRegistrationFormResponse } from 'core/gql/queries/show-form';
import * as React from 'react';
import { FormContextValues, OnSubmit } from 'react-hook-form';
import { RegistrationSteps } from './types';
import { StepperSubmitCallbackParams } from 'frontend-toolkit';

export const RegistrationContext = React.createContext<RegistrationContextType>(
  null!
);
export const useRegistrationContext = () =>
  React.useContext(RegistrationContext);

export type RegistrationContextType = {
  orgId: number;
  formId: number;
  reactHookForm: FormContextValues<ReactHookFormInputs>;
  currentStepSubmitFunction: React.MutableRefObject<
    (
      handler: StepperSubmitCallbackParams['handler']
    ) => OnSubmit<ReactHookFormInputs>
  >;
  savedFormData:
    | ShowRegistrationFormResponse['showRegistrationForm']
    | undefined;
  isLoadingSavedFormData: boolean;
  triggerChangeStep: (step: RegistrationSteps) => void;
  closeStepper: () => void;
};

export type ReactHookFormInputs = {
  enabled: boolean;
  season_dates: string | undefined | null;
};
